import { useEffect, useRef, useState } from 'react'
import { repository } from '../data/repository'
import { TIMING_FIELDS, validateTimingSettings, type TimingSettings } from '../domain/timing'

const formValues = (settings: TimingSettings) => ({
  attendance_window_seconds: String(settings.attendance_window_seconds),
  qr_rotation_seconds: String(settings.qr_rotation_seconds),
  attendance_token_ttl_seconds: String(settings.attendance_token_ttl_seconds),
})

export function SettingsPage({ onBack }: { onBack: () => void }) {
  const [values, setValues] = useState(() => formValues(repository.getSnapshot().settings))
  const [busy, setBusy] = useState(true)
  const saving = useRef(false)
  const [error, setError] = useState('')
  const [success, setSuccess] = useState('')
  useEffect(() => {
    let active = true
    void repository.getSettings().then((settings) => { if (active) setValues(formValues(settings)) })
      .catch((reason) => { if (active) setError(reason instanceof Error ? reason.message : 'No se pudo leer la configuración.') })
      .finally(() => { if (active) setBusy(false) })
    return () => { active = false }
  }, [])
  return <>
    <header className="page-back"><button onClick={onBack} aria-label="Volver">‹</button><div><h1>Configuración</h1><p>Tiempos de asistencia</p></div></header>
    <form className="focus-card timing-settings" onSubmit={async (event) => {
      event.preventDefault()
      if (busy || saving.current) return
      saving.current = true
      setError(''); setSuccess(''); setBusy(true)
      try {
        const input = validateTimingSettings({ attendance_window_seconds: Number(values.attendance_window_seconds), qr_rotation_seconds: Number(values.qr_rotation_seconds), attendance_token_ttl_seconds: Number(values.attendance_token_ttl_seconds) })
        const saved = await repository.updateSettings(input)
        setValues(formValues(saved)); setSuccess('Configuración guardada. Se aplicará a las próximas sesiones; las ya iniciadas no cambian.')
      } catch (reason) { setError(reason instanceof Error ? reason.message : 'No se pudo guardar la configuración.') }
      finally { saving.current = false; setBusy(false) }
    }}>
      <p className="muted">Estos valores se toman al iniciar una sesión. No cambian sesiones activas.</p>
      {TIMING_FIELDS.map((field) => <label key={field.key}>{field.label} (segundos)
        <input type="number" min={field.min} max={field.max} step="1" required disabled={busy} value={values[field.key]} onChange={(event) => { setSuccess(''); setValues({ ...values, [field.key]: event.target.value }) }} />
        <small>{field.help} Rango: {field.min}–{field.max} segundos.</small>
      </label>)}
      {error && <p className="notice notice--error" role="alert">{error}</p>}
      {Number(values.attendance_token_ttl_seconds) < Number(values.qr_rotation_seconds) && <p className="notice">La validez es menor que la rotación: el QR se renovará al caducar para no mostrar uno vencido.</p>}
      {success && <p className="notice" role="status">{success}</p>}
      <button type="submit" className="button button--full" disabled={busy}>{busy ? 'Procesando…' : 'Guardar'}</button>
    </form>
  </>
}
